import React from 'react'
import './VerticalNav.css'

/**
 * 왼쪽 세로 네비게이션 메뉴
 */
function VerticalNav({ activeMenu, onMenuChange, isSidebarOpen, onToggleSidebar }) {
  const isDevMode = import.meta.env.VITE_DEV_MODE === 'true'
  
  const menuItems = [
    {
      id: 'benchmark',
      label: '벤치마킹',
      badge: null,  // 완전히 활성화
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      )
    },
    {
      id: 'script',
      label: 'AI 대본',
      badge: isDevMode ? null : '개발중',  // 개발 모드에서는 badge 없음
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      )
    },
    {
      id: 'image',
      label: 'AI 이미지',
      badge: isDevMode ? null : '개발중',  // 개발 모드에서는 badge 없음
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
      )
    },
    {
      id: 'stock',
      label: '무료 스톡',
      badge: null,  // 완전히 활성화
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <path d="M9 10h6v11H9z" />
          <circle cx="12" cy="5.5" r="2.5" />
        </svg>
      )
    },
    {
      id: 'video',
      label: '영상 합치기',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="23 7 16 12 23 17 23 7" />
          <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
        </svg>
      )
    },
    {
      id: 'analytics',
      label: '채널 분석',
      badge: isDevMode ? null : '개발중',  // 개발 모드에서는 badge 없음
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      )
    },
    {
      id: 'youtube',
      label: 'YouTube 인기',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="5 3 19 12 5 21 5 3" />
        </svg>
      )
    }
  ]

  return (
    <nav className="vertical-nav">
      {/* 사이드바 토글 버튼 */}
      <button
        className="sidebar-toggle-btn"
        onClick={onToggleSidebar}
        title={isSidebarOpen ? '사이드바 닫기' : '사이드바 열기'}
      >
        {isSidebarOpen ? (
          <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="currentColor">
              <path d="m21 20c-.5523 0-1-.4477-1-1v-14c0-.55229.4477-1 1-1s1 .44771 1 1v14c0 .5523-.4477 1-1 1z"/>
              <path d="m18 12c0 .5523-.4477 1-1 1h-11.58579l2.2929 2.2929c.39052.3905.39052 1.0237 0 1.4142-.39053.3905-1.02369.3905-1.41422 0l-4-4c-.39052-.3905-.39052-1.0237 0-1.4142l4-4.00001c.39053-.39052 1.02369-.39052 1.41422 0 .39052.39053.39052 1.02369 0 1.41422l-2.2929 2.29289h11.58579c.5523 0 1 .4477 1 1z"/>
            </g>
          </svg>
        ) : (
          <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="currentColor">
              <path d="m3 4c.55228 0 1 .44772 1 1v14c0 .5523-.44771 1-1 1-.55228 0-1-.4477-1-1v-14c0-.55228.44771-1 1-1z"/>
              <path d="m6 12c0-.5523.44772-1 1-1h11.5858l-2.2929-2.29289c-.3905-.39053-.3905-1.02369 0-1.41422.3905-.39052 1.0237-.39052 1.4142 0l4 4.00001c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l2.2929-2.2929h-11.5858c-.55228 0-1-.4477-1-1z"/>
            </g>
          </svg>
        )}
      </button>
      
      {menuItems.map(item => (
        <button
          key={item.id}
          className={`nav-item ${activeMenu === item.id ? 'active' : ''} ${item.badge ? 'disabled' : ''}`}
          onClick={() => {
            if (item.badge) {
              alert(`"${item.label}" 기능은 현재 개발중입니다.`)
            } else {
              onMenuChange(item.id)
            }
          }}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">
            {item.label}
            {item.badge && <span className="nav-badge">{item.badge}</span>}
          </span>
        </button>
      ))}
    </nav>
  )
}

export default VerticalNav